<header class="modal-header">
  <h2>Fair Supply is best viewed on a desktop device.</h2>
</header>
<section class="modal-body">
  <p>To get the most from Fair Supply, we don't recommend viewing on a mobile device at this time. Sorry for any inconvenience</p>
</section>
<footer class="modal-footer">
  <button class="btn btn-outline" (click)="bsModalRef.hide()">View Anyway</button>
</footer>
